export const STORE_IMPORT_SAMPLE_CSV =
  "Store Id,Name,Retailer,Address,Postcode,City,State,Country,Latitude,Longitude,Category\n" +
  "store-001,Main Street Store,RetailerA,123 Main St,12345,New York,New York,US,40.7128,-74.0060,Electronics\n" +
  "store-002,Downtown Shop,RetailerB,456 Oak Ave,67890,Los Angeles,California,US,34.0522,-118.2437,Grocery\n" +
  "store-003,Uptown Market,RetailerC,789 Pine Rd,11111,Chicago,Illinois,US,41.8781,-87.6298,Beverage";
